/**
 * Created by Carsten Bühler
 * User: CBuehler on 23.10.2015
 * Copyright: xdot GmbH 2015
 */

const toBoolean = (value, defaultUndefinedValue=false) => {
    if (value === undefined || value===null){
        return defaultUndefinedValue;
    }
    if (typeof value === 'boolean'){
        return value;
    }
    if (typeof value === 'string'){
        return value.toLowerCase() === 'true';
    }
    throw new Error('unexpected value for toBoolean' + value);
};

export { toBoolean };



// WEBPACK FOOTER //
// ./js/utils/bool-util.js